import axios from 'axios';
import { ajaxUri } from '../../../consts/index';

export const fetchLangs = (loadIncrement = null) => {
    return dispatch => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'getLangs'
            }
        })
        .then(result => {
            if( loadIncrement )
                dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)});

            let langs = [];

            for (const lang of result.data) {
                langs.push({
                    label: lang.iso_code,
                    value: lang.id_lang
                })

                if( lang.dashboard ) {
                    dispatch({type:'SET_CURRENTLANG',lang:lang.id_lang});
                }
            }
            
            dispatch({type:'LIST_LANGS',langs:langs});
        }).catch(error => {
            console.error('Cannot fetch langs')
        });
    }
}

export const getTranslations = (loadIncrement = null) => {
    return dispatch => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'getTranslations'
            }
        })
        .then(result => {
            if( loadIncrement )
                dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)})
            
            dispatch({type:'TRANSLATE',object:JSON.parse(result.data)});
        }).catch(error => {
            console.error('Cannot get translations')
        });
    }
}

export const switchLang = (lang) => {
    return dispatch => {
        dispatch({type:'SET_CURRENTLANG',lang:lang});
    }
}